export const GET_OFFERING_VARIATIONS = "host/offering/variant/get";
export const CREATE_OFFERING_VARIATION = "host/offering/variant/create";
export const UPDATE_OFFERING_VARIATION = "host/offering/variant/update";

export const GET_MEMBERSHIP_OFFERING_VARIATIONS = "host/offering/variant/get";
export const MANAGE_OFFERING_VARIATION_BRANDED_COMMUNITY =
  "/host/membership/variant/manage";
export const GET_MEMBERSHIP_OFFERING_VARIATIONS_PATHNAME = ({ offeringUuid }) =>
  `host/offering/variant/get?listing_uuid=${offeringUuid}&page=1&page_size=50`;
export const GET_OFFERING_VARIATIONS_MEMBERHSIP_ID_PATHNAME = ({
  offeringUuid,
  membershipUuid,
}) =>
  `host/offering/variant/get?listing_uuid=${offeringUuid}&membership_uuid=${membershipUuid}`;
